'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import promise from '../utils/promise';
import _map from 'lodash/map';
import _find from 'lodash/find';

class Select extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            isOpen: false,
            options: null,
        }
    }

    componentDidMount()
    {
        this.getOptions( this.props );
    }

    componentWillReceiveProps(nextProps)
    {
        if (this.props.options !== nextProps.options)
            this.getOptions( nextProps );
    }

    toogle()
    {
        const value = !this.state.isOpen;
        this.setState({
            isOpen: value
        });
    }

    label()
    {
        const { value, placeholder } = this.props;
        const { options } = this.state;

        if (!options || !value)
            return placeholder;

        const selected = _find(options, { 'value': value });
        return selected.label;
    }

    getOptions(props)
    {
        const { options } = props;

        if (!options)
            return;

        promise(options)
        .then( response => {
            this.setState({
                options: response.data.data
            })
        })
        .catch( error => {
            console.log(error);
        })
    }

    render()
    {
        const { classe, parent } = this.props;
        const { isOpen, options } = this.state;

        return (
            <div className="co-sm-12 text-center">
                <div className={ 'selectBox ' + classe  } onClick={ () => this.toogle() }>
                    <span className='selected'>{ this.label() }</span>
                    { isOpen ?
                    <div className="selectOptions" >
                        <Link className="selectOption"
                                to={parent}>
                                    Todos os produtos
                            </Link>
                        { _map( options, (item, index) => {
                            return (
                                <Link key={ index }
                                    className="selectOption"
                                    to={parent + item.value}>
                                        { item.label }
                                </Link>
                            )
                        })}
                    </div>
                    : null }
                </div>
            </div>
        );
    }
}

Select.propTypes = {
    classe: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string,
    options: PropTypes.string,
    parent: PropTypes.string
}

Select.defaultPros = {
    classe: null,
    options: []
}

export default Select;


// WEBPACK FOOTER //
// ./resources/assets/js/app/components/Select.js